export enum MigrationStatus {
  NOT_INVITED = 1,
  PENDING = 2,
  ACTIVE = 3
}

export const migrationStatusData = [
  { name: 'Todos', status: null },
  { name: 'Não verificado', status: MigrationStatus.NOT_INVITED },
  { name: 'Pendente', status: MigrationStatus.PENDING },
  { name: 'Verificado', status: MigrationStatus.ACTIVE }
];

export function getMigrationStatus (migrationStatus: number | string): MigrationStatus {
  switch (migrationStatus) {
    case MigrationStatus.PENDING:
    case 'PENDING':
      return MigrationStatus.PENDING
    case MigrationStatus.ACTIVE:
    case 'ACTIVE':
      return MigrationStatus.ACTIVE
    default:
      return MigrationStatus.NOT_INVITED
  }
}

export function getMigrationStatusName (migrationStatus: MigrationStatus | string): string {
  switch (migrationStatus) {
    case MigrationStatus.PENDING:
    case 'PENDING':
      return 'Pendente'
    case MigrationStatus.ACTIVE:
    case 'ACTIVE':
      return 'Verificado'
    default:
      return 'Não verificado'
  }
}

export function getMigrationStatusStyle (migrationStatus: MigrationStatus | string): object {
  switch (migrationStatus) {
    case MigrationStatus.PENDING:
    case 'PENDING':
      return { color: '#818181', backgroundColor: '#FFD8A6' }
    case MigrationStatus.ACTIVE:
    case 'ACTIVE':
      return { color: '#51C4C9', backgroundColor: '#CCEAEB' }
    default:
      return { color: '#818181', backgroundColor: '#DCDCDC' }
  }
}
